namespace SP {
    export interface WarehouseReasonInfo {
        id: string,
        name: string,
        defaultReason: boolean,
        complaint: boolean,
    }
}